import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '分类大全', path: '/category/lian-ai' },
      { label: '排行榜', path: '/category/dong-zuo' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '恋爱漫画', path: '/category/lian-ai' },
      { label: '奇幻漫画', path: '/category/qi-huan' },
      { label: '动作漫画', path: '/category/dong-zuo' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '平台声誉', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '阅读指南', path: '/about' },
      { label: '常见问题', path: '/about' },
      { label: '用户反馈', path: '/about' },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setSubmitStatus('success');
      setSubmitMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setSubmitStatus('loading');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d96fafn0d76aer3t53t0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setSubmitMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败，请稍后再试';
        setSubmitStatus('error');
        setSubmitMessage(serverMsg.includes('spam') ? '订阅失败，请稍后再试' : serverMsg);
      }
    } catch {
      setSubmitStatus('error');
      setSubmitMessage('网络错误，请检查网络后重试');
    }
  };

  return (
    <footer className="bg-secondary-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px]">
          <i className="ri-earth-line text-white" style={{ fontSize: '600px' }}></i>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-8">
        <div className="flex flex-col lg:flex-row gap-12 mb-14">
          <div className="lg:w-2/5">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-3xl font-bold text-white">
                51漫画网
                <span className="inline-block w-2.5 h-2.5 rounded-full bg-accent-500 ml-1.5 align-top mt-1"></span>
              </span>
            </Link>

            <form
              onSubmit={handleSubscribe}
              data-readdy-form
              className="flex items-center gap-0 mb-6"
            >
              <div className="relative flex-1">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅更新"
                  required
                  className="w-full px-4 py-3 rounded-l-lg bg-secondary-800 border border-secondary-700 text-white placeholder:text-secondary-400 text-sm focus:outline-none focus:border-accent-500 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
              </div>
              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                className="w-11 h-11 flex items-center justify-center rounded-r-lg bg-accent-500 hover:bg-accent-600 text-white transition-colors cursor-pointer disabled:opacity-70"
              >
                <i className={`ri-${submitStatus === 'loading' ? 'loader-4-line animate-spin' : 'notification-3-line'} text-lg`}></i>
              </button>
            </form>

            {submitStatus !== 'idle' && (
              <p className={`text-xs mb-6 ${submitStatus === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                {submitMessage}
              </p>
            )}

            <p className="font-heading text-2xl text-white/80 leading-relaxed">
              免费韩漫大全<br />下拉式高效阅读
            </p>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h5 className="text-white font-semibold text-sm mb-4">{col.title}</h5>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-secondary-300 hover:text-accent-400 text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-secondary-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-400 text-xs">
            &copy; 2026 51漫画网 - 免费韩漫大全，下拉式高效阅读
          </p>

          <div className="flex items-center gap-3">
            {['wechat', 'weibo', 'bilibili', 'qq'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-secondary-600 text-secondary-300 hover:text-accent-400 hover:border-accent-500 transition-all duration-200 cursor-pointer"
                rel="nofollow"
              >
                <i className={`ri-${icon}-line`}></i>
              </a>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-400 text-xs hover:text-accent-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-secondary-400 text-xs hover:text-accent-400 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}